import React, { useEffect, useState, useMemo } from 'react';
import { shape, string } from 'prop-types';

import Box from '@material-ui/core/Box';

import { useAppContext } from '../../../../context/AppProvider';
import { DraftPicksPlayerListItem } from '../../../../components/Draft/DraftPicks/Item/DraftPicksPlayerListItem';
import Text from '../../../../components/Common/Text';

import s from './DraftPicksPlayerListContainer.module.scss';
import { fillRosterSlots } from '../../../../utils/players';

export const DraftPicksPlayerListContainer = ({ draft, userId }) => {
  const [{ user }] = useAppContext();
  const [filledRoster, setFilledRoster] = useState([]);

  const { roster } = draft?.contest?.rules;
  
  const getTitle = () => {
    return user.attributes.sub === userId ? 'My Picks' : draft?.order.find((fr) => fr.userId === userId)?.franchiseName || 'Unknown Franchise';
  };

  const contestSlots = roster?.positions.map((slot) => Array.from(new Array(slot.starters)).map(() => slot.position)).flat();
  const sortOrder = ['QB', 'RB', 'WR', 'TE', 'FLEX', 'BN'];
  const positions = contestSlots.sort((a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b));

  const rosterSlots = positions.map((position) => ({
    fantasyPosition: '',
    fullName: '',
    photoUrl: '',
    rosterSlot: position,
    team: '',
    byeWeek: '',
  }));

  const flexPositions = roster?.positions.filter((pos) => pos.flex === 1).map((p) => p.position);
  
  const draftedPlayers = draft?.summary
    ?.filter((item) => item.franchise.userId === userId)
    .map((item) => ({ ...item.player, canFlex: flexPositions.includes(item.player.fantasyPosition) }));

  useEffect(() => {
    const filledRosterByPosition = fillRosterSlots(rosterSlots, draftedPlayers);
    console.log('Filled Roster:', filledRosterByPosition);
    setFilledRoster(filledRosterByPosition);
  }, [draft?.summary, userId]);

  return (
    <Box className={s.root}>
      <Text bold variant="body1">
        {getTitle()}
      </Text>
      {filledRoster.map((slot, i) => (
        <DraftPicksPlayerListItem
          key={slot.playerId}
          draftid={draft.draftId}
          rosterslot={positions[i]}
          fullname={slot.fullName}
          photourl={slot.photoUrl}
          position={slot.fantasyPosition}
          team={slot.team}
          byeweek={slot.byeWeek}
        />
      ))}
    </Box>
  );
};

DraftPicksPlayerListContainer.propTypes = {
  draft: shape({}),
  userId: string,
};
